<template>
  <div class="dx-choose-new-game dx-choose-tips">
    <p class="subtitle">{{ $t('chooseTipsQuantity') }}</p>
    <div class="dx-choose-new-game__options">
      <dx-button
        v-for="item in options"
        @click.native="onChange(item)"
        :key="item"
        :default="item !== tips"
        :info="item === tips"
        large
        >
        {{ item }}
      </dx-button>
    </div>
  </div>
</template>

<script>
import DxButton from './DxButton.vue'
export default {
  name: 'dx-choose-tips',
  components: { DxButton },
  data () {
    return {
      options: [7, 10, 15],
      tips: 10
    }
  },
  methods: {
    onChange (tips) {
      this.tips = tips
      this.$emit('change', this.tips)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DxChooseTips.vue